var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":_vm.chart.id}}),(_vm.chart.noData)?_c('div',{staticStyle:{"line-height":"300px","text-align":"center","width":"100"}},[_vm._v("暂无数据")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }